export default "__VITE_ASSET__nNss$pCX__"